export default __webpack_public_path__ + "static/Group 650-71744801e307f13996a224a2fe481cbc.png";